import * as yup from 'yup';

function phoneNumber(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'PHONE_NUMBER_IS_REQUIRED',
      defaultMessage: 'Phone number is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      phoneNumber: phoneNumber(formatMessage),
      description: yup.string().nullable(),
      isVoiceEnabled: yup.boolean(),
      isVoiceDefault: yup.boolean().test(
        'voice-default-requires-enabled',
        formatMessage({
          id: 'INSIGHT_CONTACT_VOICE_DEFAULT_REQUIRES_ENABLED',
          defaultMessage:
            'Voice must be enabled before it can be set as the default',
        }),
        (value, context) => !value || context.parent.isVoiceEnabled === true,
      ),
      isTextEnabled: yup.boolean(),
      isTextDefault: yup.boolean().test(
        'text-default-requires-enabled',
        formatMessage({
          id: 'INSIGHT_CONTACT_TEXT_DEFAULT_REQUIRES_ENABLED',
          defaultMessage:
            'SMS opt-in must be enabled before it can be set as the default',
        }),
        (value, context) => !value || context.parent.isTextEnabled === true,
      ),
    })
    .required();

export default validationSchema;
